import { FindVehiclesRequest, FindVehiclesResponse } from "@tm/models"
import { ajaxAuth, mapVehicleShortInfo, notUndefinedOrNull } from "@tm/utils"
import { getVehicleGsiServiceUrl } from "./helper"

export async function findVehicles(body: FindVehiclesRequest): Promise<FindVehiclesResponse | undefined> {
    const response = await ajaxAuth<FindVehiclesResponse>({
        url: `${getVehicleGsiServiceUrl()}/FindVehicles`,
        body,
    })

    if (!response) {
        return undefined
    }

    return {
        ...response,
        vehicles: response.vehicles?.map(mapVehicleShortInfo).filter(notUndefinedOrNull) ?? [],
    }
}
